import { useState, useEffect, useRef } from 'react'
import { useWhatsApp } from '../context/WhatsAppProvider'
import artcustomAws from '../images/artcustom-aws.jpeg'
import artcustomPackage from '../images/artcustom-package.jpeg'
import empCamisetaClassica from '../images/empresas-camiseta-clássica.png'
import empCamisetaPolo from '../images/empresas-camiseta-polo.png'
import empCamisetaBabyLook from '../images/empresas-camiseta-baby-look.png'
import empCamisetaBabyPolo from '../images/empresas-camiseta-baby-polo.jpeg'
import empCamisetaDryFit from '../images/empresas-camiseta-dry-fit.png'
import empDryFitPremium from '../images/empresas-dry-fit-premium.png'
import empCalcaBrim from '../images/empresas-calça-brim.png'
import empCamisetaPremium from '../images/empresas-camiseta-premium.png'
import empCamisetaBasica from '../images/empresas-camiseta-basica.png'
import marcasRegataOverBall from '../images/marcas-regata-over-ball.jpeg'
import marcasOverBoxy from '../images/marcas-over-boxy.jpeg'
import marcasCamisetaClassica from '../images/marcas-camiseta-classica.png'
import marcasCamisaOver from '../images/marcas-camisa-overjpeg.jpeg'
import marcasDesign from '../images/marcas-design.jpeg'
import igTag from '../images/impressoes-graficas-tag.jpg.jpeg'
import igCartao from '../images/impressoes-graficas-cartão de visita.jpg.jpeg'
import igBanner from '../images/impressoes-graficas-bannner.png'
import igAdesivos from '../images/impressoes-graficas-adesivos.png'

interface ProductCard {
  name: string
  variant: string
  description: string
  image: string
}

const categories = [
  {
    title: 'Empresas',
    subtitle: 'Que buscam padronização, conforto e uma identidade visual profissional',
    coverImages: [
      artcustomAws,
      empCamisetaPremium,
      empCamisetaBasica,
    ],
    products: [
      {
        name: 'Camiseta',
        variant: 'Básica',
        description: 'Ideal para eventos, equipes, ações promocionais e brindes, oferecendo padronização, conforto e um excelente custo benefício.',
        image: empCamisetaBasica,
      },
      {
        name: 'Camiseta',
        variant: 'Clássica',
        description: 'Ideal para uniformes, uma opção que oferece mais conforto, melhor acabamento e maior durabilidade.',
        image: empCamisetaClassica,
      },
      {
        name: 'Camiseta',
        variant: 'Premium',
        description: 'Ideal para quem busca máximo conforto, alta qualidade e uma apresentação mais sofisticada, em algodão egípcio, com toque extremamente macio e acabamento superior.',
        image: empCamisetaPremium,
      },
      {
        name: 'Camiseta',
        variant: 'Polo Unissex',
        description: 'Ideal para uniformes corporativos, equipes e empresas que buscam sofisticação e profissionalismo.',
        image: empCamisetaPolo,
      },
      {
        name: 'Camiseta Clássica',
        variant: 'Baby Look',
        description: 'Versátil, para todo e qualquer momento. Uma opção que oferece mais conforto, melhor acabamento e maior durabilidade',
        image: empCamisetaBabyLook,
      },
      {
        name: 'Camiseta Polo',
        variant: 'Polo Feminina',
        description: 'Ideal para uniformes corporativos, equipes e empresas que buscam sofisticação.',
        image: empCamisetaBabyPolo,
      },
      {
        name: 'Camiseta Dry Fit',
        variant: 'Feminina',
        description: 'Perfeita para atividades físicas, eventos esportivos e equipes que precisam de conforto térmico.',
        image: empCamisetaDryFit,
      },
      {
        name: 'Camiseta Dry Fit',
        variant: 'Premium',
        description: 'Oferece mais flexibilidade, conforto e ajuste ao corpo para melhor desempenho.',
        image: empDryFitPremium,
      },
      {
        name: 'Calça Brim',
        variant: 'Unissex',
        description: 'Perfeita para uniformes que exigem durabilidade e conforto no dia a dia de trabalho.',
        image: empCalcaBrim,
      },
    ] as ProductCard[],
  },
  {
    title: 'Marcas',
    subtitle: 'Que priorizam qualidade, conforto, durabilidade e autenticidade',
    coverImages: [
      artcustomPackage,
      marcasDesign,
      marcasCamisetaClassica,
    ],
    products: [
      {
        name: 'Camiseta',
        variant: 'Clássica',
        description: 'Uma peça versátil, com qualidade e um visual tradicional.',
        image: marcasCamisetaClassica,
      },
      {
        name: 'Camiseta',
        variant: 'Oversized Premium',
        description: 'Desenvolvida para marcas que buscam peças com presença e qualidade superior',
        image: marcasCamisaOver,
      },
      {
        name: 'Camiseta',
        variant: 'Over Boxy',
        description: 'Perfeita para marcas que procuram um estilo atual e diferenciado para suas coleções.',
        image: marcasOverBoxy,
      },
      {
        name: 'Regata',
        variant: 'Overball',
        description: 'Modelagem ampla e confortável, ideal para coleções próprias e personalização com estilo.',
        image: marcasRegataOverBall,
      },
      {
        name: 'Oversized',
        variant: 'Personalizado',
        description: 'Criação exclusiva de estampas e artes para a identidade da sua marca.',
        image: marcasDesign,
      },
    ] as ProductCard[],
  },
  {
    title: 'Impressões Gráficas',
    subtitle: 'Tags, cartões de visita, banners e adesivos personalizados',
    coverImages: [
      igTag,
      igBanner,
      igAdesivos,
    ],
    products: [
      {
        name: 'Tag',
        variant: 'Personalizada',
        description: 'Ideais para identificação de produtos, trazendo mais profissionalismo e identidada para sua marca',
        image: igTag,
      },
      {
        name: 'Cartão de Visita',
        variant: 'Personalizado',
        description: 'Uma forma prática e elegante de apresentar sua empresa e fortalecer a identidade da sua marca',
        image: igCartao,
      },
      {
        name: 'Banner',
        variant: 'Personalizado',
        description: 'Perfeitos para eventos, promoções, fachadas e comunicação visual, garantindo alta visibilidade e qualidade de impressão',
        image: igBanner,
      },
      {
        name: 'Adesivos',
        variant: 'Personalizados',
        description: 'Ideais para embalagens, produtos, vitrines e comunicação visual, com impressão de alta qualidade e excelente durabilidade',
        image: igAdesivos,
      },
    ] as ProductCard[],
  },
]

const CoverSlider = ({ images }: { images: string[] }) => {
  const [current, setCurrent] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length)
    }, 4000)
    return () => clearInterval(interval)
  }, [images.length])

  return (
    <>
      {images.map((src, i) => (
        <img
          key={i}
          src={src}
          alt=""
          className={`absolute inset-0 w-full h-full object-cover ${
            i === current ? 'opacity-100 scale-105' : 'opacity-0 scale-100'
          }`}
          style={{ transition: 'opacity 1s ease, transform 8s ease' }}
          loading="lazy"
        />
      ))}
    </>
  )
}

const ProductCarousel = ({
  category,
  onClose,
}: {
  category: (typeof categories)[0]
  onClose: () => void
}) => {
  const scrollRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    document.body.style.overflow = 'hidden'
    window.addEventListener('keydown', handleKey)
    return () => {
      document.body.style.overflow = ''
      window.removeEventListener('keydown', handleKey)
    }
  }, [onClose])

  const scroll = (dir: 'left' | 'right') => {
    if (!scrollRef.current) return
    const amount = 320
    scrollRef.current.scrollBy({ left: dir === 'left' ? -amount : amount, behavior: 'smooth' })
  }

  const { openWhatsApp } = useWhatsApp()

  const handleProductQuote = () => {
    openWhatsApp()
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/85 backdrop-blur-sm animate-fadeIn"
      onClick={onClose}
    >
      <button
        onClick={onClose}
        className="absolute top-6 right-6 text-white/70 hover:text-white transition-colors z-10"
      >
        <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      <div
        className="w-full max-w-6xl mx-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="text-center mb-8">
          <h3 className="text-3xl md:text-4xl font-bold text-white">{category.title}</h3>
          <p className="text-white/60 mt-2 text-lg">{category.subtitle}</p>
        </div>

        <div className="relative">
          <button
            onClick={() => scroll('left')}
            className="absolute -left-4 top-1/2 -translate-y-1/2 z-10 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 backdrop-blur-sm flex items-center justify-center text-white transition-colors"
          >
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          <div
            ref={scrollRef}
            className="flex gap-6 overflow-x-auto pb-4 scrollbar-hide snap-x snap-mandatory px-2"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {category.products.map((product, i) => (
              <div
                key={i}
                className="flex-shrink-0 w-[280px] snap-center bg-white rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 flex flex-col"
              >
                <div className="h-[320px] overflow-hidden">
                  <img
                    src={product.image}
                    alt={`${product.name} ${product.variant}`}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <h4 className="text-xl font-bold text-gray-900">{product.name}</h4>
                  <p className="text-[#0877c5] font-semibold mb-2">{product.variant}</p>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4 flex-1">{product.description}</p>
                  <button
                    onClick={handleProductQuote}
                    className="w-full bg-[#0877c5] hover:bg-[#0666a8] text-white py-3 rounded-xl font-semibold transition-colors duration-300 mt-auto"
                  >
                    Orçamento
                  </button>
                </div>
              </div>
            ))}
          </div>

          <button
            onClick={() => scroll('right')}
            className="absolute -right-4 top-1/2 -translate-y-1/2 z-10 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 backdrop-blur-sm flex items-center justify-center text-white transition-colors"
          >
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  )
}

const Products = () => {
  const [activeCategory, setActiveCategory] = useState<number | null>(null)

  return (
    <>
      {activeCategory !== null && (
        <ProductCarousel
          category={categories[activeCategory]}
          onClose={() => setActiveCategory(null)}
        />
      )}

      <section id="produtos" className="py-20 bg-gradient-to-b from-[#0078c9] to-white relative overflow-hidden">
        <div className="absolute top-1/2 left-0 w-80 h-80 bg-[#0877c5]/8 rounded-full blur-3xl -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-80 h-80 bg-[#b51625]/6 rounded-full blur-3xl"></div>

        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="w-full h-[4px] bg-white/30 mb-12"></div>
          <div className="text-center mb-16">
            <p className="text-sm font-semibold tracking-widest uppercase text-[#4da8e8] mb-3">Catálogo</p>
            <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white">
              Nossos Produtos
            </h2>
            <p className="text-xl text-white/70 max-w-2xl mx-auto">
              Explore nossa linha completa de roupas customizáveis
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {categories.map((cat, index) => (
              <div
                key={index}
                onClick={() => setActiveCategory(index)}
                className="relative h-[907px] rounded-2xl overflow-hidden group cursor-pointer shadow-lg hover:shadow-2xl transition-shadow duration-300"
              >
                <CoverSlider images={cat.coverImages} />

                <div className="absolute inset-0 bg-black/40 group-hover:bg-black/55 transition-all duration-500"></div>

                <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-8">
                  <h3 className="text-5xl md:text-6xl font-bold text-white mb-4 group-hover:translate-y-0 translate-y-1 transition-transform duration-300">
                    {cat.title}
                  </h3>
                  <p className="text-white/80 text-xl md:text-2xl mb-4 group-hover:translate-y-0 translate-y-2 transition-transform duration-500">
                    {cat.subtitle}
                  </p>
                  <span className="inline-flex items-center text-lg font-semibold text-[#4da8e8]">
                    Ver produtos
                    <svg className="w-5 h-5 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}

export default Products
